import { can, type AuthorizedUser } from '@dma/auth';
import { AuthorizationError, ApplicationError, type Logger } from '@dma/shared';
import type { ArticleRepository } from '../../domain/repositories/ArticleRepository.interface';

export class DeleteArticleUseCase {
  constructor(
    private readonly repository: ArticleRepository,
    private readonly logger: Logger
  ) {}

  public async execute(actingUser: AuthorizedUser | null, id: string): Promise<void> {
    if (!can(actingUser, 'news:delete')) {
      throw new AuthorizationError();
    }

    try {
      await this.repository.delete(id);
    } catch (error) {
      this.logger.error('Failed to delete article', {
        articleId: id,
        cause: error instanceof Error ? error.message : String(error)
      });
      throw new ApplicationError('ARTICLE_DELETE_FAILED', 'حذف مطلب با مشکل مواجه شد. لطفاً دوباره تلاش کنید.', {
        cause: error
      });
    }
  }
}
